import { Box, IconButton } from '@material-ui/core'
import { Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { useStyles } from './styles'

export interface NotificationProps {
  icon?: React.ReactNode
  footer?: React.ReactNode
  children?: React.ReactNode
  onClose?: () => void
}

export default function Notification({
  icon,
  footer,
  children,
  onClose,
}: NotificationProps) {
  const classes = useStyles()

  return (
    <Box data-testid='box' className={classes.content}>
      <div className={classes.notification}>
        {icon}
        <Typography className={classes.notificationText}>{children}</Typography>
        <IconButton
          className={classes.closeButton}
          size='small'
          aria-label='Fechar notificação'
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <div className={classes.footerContainer}>{footer}</div>
    </Box>
  )
}
